.period-picker {
    position: absolute;
    right: 16px;
    z-index: 1;
    padding: 16px;
}
